"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Tab = function Tab(_ref) {
  var label = _ref.label,
    isActive = _ref.isActive,
    tabIndex = _ref.tabIndex,
    _onClick = _ref.onClick,
    allowNavigation = _ref.allowNavigation;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "tab-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return _onClick(tabIndex, allowNavigation);
    },
    role: "button",
    tabIndex: tabIndex,
    onKeyPress: function onKeyPress() {
      return _onClick(tabIndex, allowNavigation);
    },
    className: "\n        tab-element\n        ".concat(isActive ? 'selected' : '', "\n        ").concat(allowNavigation ? 'allowedNavigation' : '', "\n      ")
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "wizzard-step ".concat(isActive ? 'selected' : '')
  }, tabIndex + 1), /*#__PURE__*/_react["default"].createElement("span", null, label)));
};
Tab.propTypes = {
  tabIndex: _propTypes["default"].number,
  isActive: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({})]).isRequired,
  allowNavigation: _propTypes["default"].bool
};
Tab.defaultProps = {
  tabIndex: 0,
  isActive: false,
  onClick: function onClick() {},
  allowNavigation: false
};
Tab.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Tab",
  "props": {
    "tabIndex": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "isActive": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "allowNavigation": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "label": {
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "shape",
          "value": {}
        }]
      },
      "required": true
    }
  }
};
var _default = Tab;
exports["default"] = _default;